import { useTranslation } from 'react-i18next';

import { Box, Button, Flex, Text } from '@bonusly/design-system';

interface BizyGameInviteProps {
	onPlay: () => void;
	onDismiss: () => void;
}

export function BizyGameInvite({ onPlay, onDismiss }: BizyGameInviteProps) {
	const { t } = useTranslation('admin_bizy');

	return (
		<Box
			data-bizy-game-invite
			role="dialog"
			aria-label={t('gameInvite.ariaLabel')}
			bg="bg.surface"
			border="1px solid"
			borderColor="border.soft"
			borderRadius="xl"
			boxShadow="lg"
			px={3}
			py={2}
			w="270px"
			maxW="calc(100vw - 32px)"
			position="relative"
			onPointerDown={(event) => event.stopPropagation()}
			onPointerUp={(event) => event.stopPropagation()}
			onPointerCancel={(event) => event.stopPropagation()}
			onClick={(event) => event.stopPropagation()}
			_after={{
				content: '""',
				position: 'absolute',
				left: '50%',
				bottom: '-7px',
				w: '14px',
				h: '14px',
				bg: 'bg.surface',
				borderRight: '1px solid',
				borderBottom: '1px solid',
				borderColor: 'border.soft',
				transform: 'translateX(-50%) rotate(45deg)',
			}}
		>
			<Text fontSize="sm" color="text.default" fontWeight="semibold">
				{t('gameInvite.title')}
			</Text>
			<Text fontSize="xs" color="text.soft" mt={1}>
				{t('gameInvite.body')}
			</Text>
			<Flex gap={2} mt={3} justify="flex-end">
				<Button size="xs" variant="ghost" colorScheme="secondary" onClick={onDismiss}>
					{t('gameInvite.notNow')}
				</Button>
				<Button size="xs" colorScheme="primary" onClick={onPlay}>
					{t('gameInvite.play')}
				</Button>
			</Flex>
		</Box>
	);
}
